/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { httpAgentFactoryFromOptions } from './configuration/otlp-node-http-configuration';
export {
  createOtlpHttpExportDelegate,
  createOtlpHttpExporterMetrics,
} from './otlp-http-export-delegate';
export { getSharedConfigurationFromEnvironment } from './configuration/shared-env-configuration';
export { convertLegacyHttpOptions } from './configuration/convert-legacy-node-http-options';
